import { registerModals } from '@bonanza-social/navigation';
import { ComponentProps, JSXElementConstructor } from 'react';
import MetaGameModal from './MetaGameModal/MetaGameModal';

const modals = {
  MetaGame: MetaGameModal,
};

registerModals('metaGames', modals);

declare global {
  interface RegisteredModals {
    metaGames: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
